<!-- Start the Breaking the Cycle page wrapper. -->
<div class="btc-page">
  <!-- Start the hero section. -->
  <section class="hero">
    <!-- Add the dark overlay used to keep hero text readable over the image. -->
    <div class="overlay"></div>
    <!-- Keep the hero content aligned with the site's standard container width. -->
    <div class="container hero-inner">
      <!-- Display the Community Services category pill. -->
      <span class="pill">Community Services</span>
      <!-- Display the main Breaking the Cycle heading. -->
      <h1>Breaking the <span>Cycle</span></h1>
      <div class="ecb-web-voc-title-line"></div>
      <!-- Display the program subheading from the supplied brief. -->
      <h2>A First Nations-led early intervention program for young men and boys — Darwin, NT</h2>
      <!-- Display the participant-focused introduction from the supplied brief. -->
      <p>Breaking the Cycle is a free, culturally grounded program for young men and boys who want to change the way
        they think about relationships, accountability, and their future. It was created for our community, with our
        community. You are not defined by your past. We walk alongside you every step of the way.</p>
      <!-- Link participants, families and referrers to the ECB contact page. -->
      <a routerLink="/contact-us" class="cta">Talk to ECB <i class="bi bi-arrow-right"></i></a>

      <a href="/assets/documents/worksafe HSR seminar.pdf" download class=" cta btn ecb-web-voc-request-button"
        style="margin-left: 1rem;">
        Join the Community Program
        <i class="bi bi-arrow-right"></i>
      </a>
    </div>
  </section>

  <!-- Start the key facts section. -->
  <section class="facts">
    <!-- Create the responsive grid used for the four key facts. -->
    <div class="container fact-grid">
      <!-- Repeat one fact card for every fact defined in the component. -->
      <article *ngFor="let f of facts">
        <!-- Display the icon assigned to the current fact. -->
        <i class="bi {{ f[0] }}"></i>
        <!-- Group the fact title and supporting text. -->
        <div>
          <!-- Display the key fact title. -->
          <strong>{{ f[1] }}</strong>
          <!-- Display the key fact supporting text. -->
          <span>{{ f[2] }}</span>
        </div>
      </article>
    </div>
  </section>

  <!-- Start the program introduction section. -->
  <section class="section">
    <!-- Use a two-column layout for the heading and description. -->
    <div class="container split">
      <!-- Display the program introduction heading. -->
      <div>
        <!-- Display the section label. -->
        <span class="kicker">What the program is</span>
        <!-- Display the section title with the highlighted phrase. -->
        <h2>Culture is the intervention — <span>not an add-on.</span></h2>
      </div>
      <!-- Display the detailed program introduction. -->
      <div>
        <!-- Explain the 16-week yarning circle and culturally grounded delivery model. -->
        <p>Breaking the Cycle is a 16-week yarning circle program for young men and boys in Darwin. Every session is
          grounded in First Nations culture, led by a First Nations male facilitator, and backed by Elders and
          community. The program is free. It is not a punishment. It is an opportunity.</p>
        <!-- Explain the program's community partnership approach. -->
        <p>The program was designed in partnership with Elders, Larrakia Nation Aboriginal Corporation, and community
          members.</p>
        <!-- Identify ECB Training Services and its RTO registration. -->
        <p><strong>Delivered by ECB Training Services</strong> — an Aboriginal-owned Registered Training Organisation
          (RTO 41369) based in Darwin, NT.</p>
      </div>
    </div>
  </section>

  <!-- Start the 16-week journey section. -->
  <section class="section journey">
    <!-- Keep the journey content aligned with the site's standard container width. -->
    <div class="container">
      <!-- Display the journey section heading. -->
      <div class="head">
        <!-- Display the section label. -->
        <span class="kicker">The 16-week journey</span>
        <!-- Display the journey section title. -->
        <h2>Practical steps toward lasting change</h2>
      </div>
      <!-- Create the responsive grid for the four journey stages. -->
      <div class="journey-grid">
        <!-- Repeat one journey card for every journey stage defined in the component. -->
        <article *ngFor="let j of journey">
          <!-- Display the journey stage number. -->
          <div class="num">{{ j[0] }}</div>
          <!-- Display the week range for the current stage. -->
          <span>{{ j[1] }}</span>
          <!-- Display the current stage title. -->
          <h3>{{ j[2] }}</h3>
          <!-- Display the current stage description. -->
          <p>{{ j[3] }}</p>
        </article>
      </div>
    </div>
  </section>

  <!-- Start the first-day information section. -->
  <section class="section first-day">
    <!-- Keep the first-day content aligned with the site's standard container width. -->
    <div class="container">
      <!-- Display the first-day section heading. -->
      <div class="head">
        <!-- Display the section label. -->
        <span class="kicker">What Happens on Your First Day</span>
        <!-- Display the first-day section title. -->
        <h2>What happens when you arrive</h2>
      </div>
      <!-- Display the first-day steps as a vertical sequence. -->
      <div class="first-list">
        <!-- Repeat one first-day step for every item defined in the component. -->
        <article *ngFor="let d of firstDay">
          <!-- Display the first-day step number. -->
          <span>{{ d[0] }}</span>
          <!-- Group the first-day step title and description. -->
          <div>
            <!-- Display the first-day step title. -->
            <h3>{{ d[1] }}</h3>
            <!-- Display the first-day step description. -->
            <p>{{ d[2] }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!-- Start the education and employment pathways section. -->
  <section class="section pathways" *ngIf="false">
    <!-- Use a two-column layout for the image and pathway content. -->
    <div class="container split align">
      <!-- Display an existing ECB community image. -->
      <div class="image">
        <!-- Load the project image with accessible alternative text. -->
        <img src="assets/images/locations/about_us_2.png" alt="ECB community and training support">
      </div>
      <!-- Display the education and employment pathway content. -->
      <div>
        <!-- Display the section label. -->
        <span class="kicker">Education and Employment Pathways</span>
        <!-- Display the pathways section heading. -->
        <h2>Real qualifications from <span>Day 1</span></h2>
        <!-- Introduce the qualifications and employment opportunities available to participants. -->
        <p>As a Breaking the Cycle participant, you have direct access to real qualifications and employment pathways.
        </p>
        <!-- Display the pathway items in a checklist. -->
        <ul>
          <!-- Repeat one pathway row for every item defined in the component. -->
          <li *ngFor="let p of pathways">
            <!-- Display the pathway check icon. -->
            <i class="bi bi-check-circle-fill"></i>
            <!-- Display the pathway description. -->
            {{ p }}
          </li>
        </ul>
      </div>
    </div>
  </section>

  <!-- Start the participant support team section. -->
  <section class="section support">
    <!-- Keep the support content aligned with the site's standard container width. -->
    <div class="container">
      <!-- Display the support section heading. -->
      <div class="head">
        <!-- Display the section label. -->
        <span class="kicker">Your Support Team</span>
        <!-- Display the support section title. -->
        <h2>People who walk alongside you</h2>
      </div>
      <!-- Create the responsive grid for support-role cards. -->
      <div class="support-grid">
        <!-- Repeat one support card for every support role defined in the component. -->
        <article *ngFor="let s of support">
          <!-- Display the support-role icon. -->
          <i class="bi bi-person-heart"></i>
          <!-- Display the support-role title. -->
          <h3>{{ s[0] }}</h3>
          <!-- Display the support-role description. -->
          <p>{{ s[1] }}</p>
        </article>
      </div>
    </div>
  </section>

  <!-- Start the referrer information and contact section. -->
  <section class="section refer">
    <!-- Create the two-column referral and contact layout. -->
    <div class="container refer-grid">
      <!-- Display the referral pathways and instructions. -->
      <div>
        <!-- Display the referrer section label. -->
        <span class="kicker light">For Referrers — How to Refer</span>
        <!-- Display the referrer section title. -->
        <h2>How to refer</h2>
        <!-- Explain the referral process and response commitment. -->
        <p>Breaking the Cycle accepts referrals through multiple pathways. There is no mandatory referral form — call or
          email and ECB will respond within 24 hours.</p>
        <!-- Display the supported referral pathways. -->
        <ul>
          <!-- Repeat one referral pathway for every item defined in the component. -->
          <li *ngFor="let r of referrals">
            <!-- Display the referral arrow icon. -->
            <i class="bi bi-arrow-right-short"></i>
            <!-- Display the referral pathway description. -->
            {{ r }}
          </li>
        </ul>
      </div>
      <!-- Display ECB's referral contact information. -->
      <aside>
        <!-- Display the contact panel heading. -->
        <h3>Contact ECB Training Services</h3>
        <!-- Provide a clickable telephone number. -->
        <a href="tel:08 7905 4026"><i class="bi bi-telephone"></i>08 7905 4026</a>
        <!-- Provide a clickable referral email address. -->
        <a href="mailto:darwin@ecbtraining.com.au"><i class="bi bi-envelope"></i>darwin&#64;ecbtraining.com.au</a>
        <!-- Display the Darwin office address. -->
        <p><i class="bi bi-geo-alt"></i>44 McMinn Street, Darwin NT 0800</p>
        <!-- Display the stated office opening hours. -->
        <p><i class="bi bi-clock"></i>Monday to Friday, 07:30 – 16:30 | Saturday and Sunday by appointment</p>
        <!-- Highlight the expected referral and enquiry response time. -->
        <div class="response">Response time: <strong>Within 24 hours</strong></div>
      </aside>
    </div>
  </section>
</div>
<!-- End the Breaking the Cycle page wrapper. -->